export class PasswordStrengthModel {
  validations: number;
  strength: number;
  strengthInPercent: number;
}
